import { render, staticRenderFns } from "./goToApp.vue?vue&type=template&id=33aade4a&scoped=true&"
import script from "./goToApp.vue?vue&type=script&lang=js&"
export * from "./goToApp.vue?vue&type=script&lang=js&"
import style0 from "./goToApp.vue?vue&type=style&index=0&id=33aade4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aade4a",
  null
  
)

export default component.exports